import {
    trackPWAInstallPrompt,
    trackPWAInstallation,
} from "../analytics/analytics-events";

trackPWAInstallPrompt();
trackPWAInstallation();
